import { useEffect, useState } from 'react'
import { useRouteFeatureMarkersActions, useRouteFeatureMarkersState } from "../../../stores/MapLayers/RouteFeatureMarkersStore";
import vegkameraIconResource from "../../../assets/cctv.svg"

export function RoadFeaturesMapLayer(){
    const [className, setClassName] = useState('mapLayerContainerInactive');

    const open = useRouteFeatureMarkersState();
    const { toggleOpen } = useRouteFeatureMarkersActions();

    useEffect(() => {
        if(open){
            setClassName('mapLayerContainerActive')
        }
        else{
            setClassName('mapLayerContainerInactive')
        }
    }, [open])


    return(
        <div style={{display: 'grid', marginLeft: '20px', maxHeight: '90%'}}>
            <div className={className} onClick={toggleOpen}>
                <img src={vegkameraIconResource} alt="Rute elementer kartlag" style={{width: '28px', height: '6vh', margin: 'auto'}}/>
            </div>
            <p style={{fontSize: '14px', margin: 'auto', fontWeight: 'bold'}}>Ruteelementer</p>
        </div>
    )
}